module.exports = __webpack_public_path__ + "static/media/unverifiedAccount.6e98e919.png";